import React from 'react';

import { useLocale } from '@adsk/alloy-react-locale';
import theme, { StylableComponent } from '@adsk/alloy-react-theme';

const Placeholder = ({
  children,
  style,
  ...props
}: StylableComponent<HTMLDivElement>) => {
  const { T } = useLocale(({ locale }) => require(`../../i18n/${locale}.json`));
  const placeholder = children || T.translate('SELECT');

  return (
    <div
      css={[
        theme.typography.labelMedium,
        theme.typography.ellipsis,
        {
          color: theme.tokens.colors.text.tertiary.value,
          pointerEvents: 'none',
          userSelect: 'none',
          flex: 1,
        },
        style,
      ]}
      {...props}
    >
      {placeholder}
    </div>
  );
};

export default Placeholder;
